import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../environments/environment';

@Pipe({
  name: 'appMode',
  standalone: false,
})
export class AppModePipe implements PipeTransform {
  public transform(mode: 'bwm' | 'liberro'): boolean {
    return environment.appBuildMode === mode;
  }
}